import React from "react";
import {I18nContext} from "./i18nContext";
import {I18nProviderProps, Locale, CleanedLocale} from "./types";
import {makeLocalize} from "./localize";
import {makeFormatCurrency} from "./formatCurrency";

const cleanLocale = (locale: Locale): Locale =>
  locale.replace("_", "-") as Locale;

export function I18nProvider({
  translations,
  locale,
  children,
}: I18nProviderProps): JSX.Element {
  const cleanedLocale = cleanLocale(locale) as CleanedLocale;
  const translationsForLocale = translations[cleanedLocale]?.translation ?? {};
  const localize = makeLocalize(translationsForLocale, cleanedLocale);
  const formatCurrency = makeFormatCurrency(cleanedLocale);
  return (
    <I18nContext.Provider
      value={{
        locale: cleanedLocale,
        translations: translationsForLocale,
        localize,
        formatCurrency,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
}
